export const GET_DATA_DOWNLOAD_LIST_REQUEST = 'GET_DATA_DOWNLOAD_LIST_REQUEST'
export const GET_DATA_DOWNLOAD_LIST_SUCCESS = 'GET_DATA_DOWNLOAD_LIST_SUCCESS'
export const GET_DATA_DOWNLOAD_LIST_FAILED = 'GET_DATA_DOWNLOAD_LIST_FAILED'
export const UPDATE_DATA_DOWNLOAD_REQUEST = 'UPDATE_DATA_DOWNLOAD_REQUEST'
export const UPDATE_DATA_DOWNLOAD_FAILED = 'UPDATE_DATA_DOWNLOAD_FAILED'
export const UPDATE_DATA_DOWNLOAD_SUCCESS = 'UPDATE_DATA_DOWNLOAD_SUCCESS'
export const CLEAR_DATA_DOWNLOAD = 'CLEAR_DATA_DOWNLOAD'
